import React from "react";
import styles from "./favorite.module.scss";
import prodStyles from "./product.module.scss";
import * as utils from "../../utils/utils";

function Favorite(props) {

  const {
    title,
    type,
    subTitle,
    view,
    ViewType,
    detailPageId
  } = props.favorite;

  let name,
    cxScore,
    lastQuarterCxScore,
    cas,
    lastQuarterCas,
    volatility,
    recommendation,
    cxBenchmark,
    casBenchmark,
    responseCount;

  if (detailPageId === 1) {
    name = props.favorite.InputParameters.group.name
    cxScore = props.favorite.InputParameters.group.cxScore
    lastQuarterCxScore = props.favorite.InputParameters.group.lastQuarterCxScore
    cas = props.favorite.InputParameters.group.cas
    lastQuarterCas = props.favorite.InputParameters.group.lastQuarterCas
    volatility = props.favorite.InputParameters.group.volatility
    recommendation = props.favorite.InputParameters.group.recommendation
    cxBenchmark = props.favorite.InputParameters.group.cxBenchmark
    casBenchmark = props.favorite.InputParameters.group.casBenchmark
    responseCount = props.favorite.InputParameters.group.responseCount
  } else if (detailPageId === 2) {
    name = utils.textLimitTo(utils.capitalize(props.favorite.InputParameters.customer.name), 20)
    cxScore = props.favorite.InputParameters.customer.cxScore
    lastQuarterCxScore = props.favorite.InputParameters.customer.lastQuarterCxScore
    cas = props.favorite.InputParameters.customer.cas
    lastQuarterCas = props.favorite.InputParameters.customer.lastQuarterCas
    volatility = props.favorite.InputParameters.customer.volatility
    recommendation = props.favorite.InputParameters.customer.recommendation
    cxBenchmark = props.favorite.InputParameters.customer.cxBenchmark
    casBenchmark = props.favorite.InputParameters.customer.casBenchmark
    responseCount = props.favorite.InputParameters.customer.responseCount

    const { productDivision } = props.favorite.InputParameters
    if (!utils.isEmpty(productDivision)) {
      name = `<div class="favoriteFlex"><div>${productDivision.code}</div><div class="forwardTitleArrow"></div><div>${utils.textLimitTo(name, 15)}</div></div>`
    }

  } if (detailPageId === 3) {
    name = props.favorite.InputParameters.productDivision.code
    cxScore = props.favorite.InputParameters.productDivision.cxScore
    lastQuarterCxScore = props.favorite.InputParameters.productDivision.lastQuarterCxScore
    cas = props.favorite.InputParameters.productDivision.cas
    lastQuarterCas = props.favorite.InputParameters.productDivision.lastQuarterCas
    volatility = props.favorite.InputParameters.productDivision.volatility
    recommendation = props.favorite.InputParameters.productDivision.recommendation
    cxBenchmark = props.favorite.InputParameters.productDivision.cxBenchmark
    casBenchmark = props.favorite.InputParameters.productDivision.casBenchmark
    responseCount = props.favorite.InputParameters.productDivision.responseCount
  } else if (detailPageId === 4) {
    const { productDivision } = props.favorite.InputParameters
    name = props.favorite.InputParameters.sbs.code
    cxScore = props.favorite.InputParameters.sbs.cxScore
    lastQuarterCxScore = props.favorite.InputParameters.sbs.lastQuarterCxScore
    cas = props.favorite.InputParameters.sbs.cas
    lastQuarterCas = props.favorite.InputParameters.sbs.lastQuarterCas
    volatility = props.favorite.InputParameters.sbs.volatility
    recommendation = props.favorite.InputParameters.sbs.recommendation
    cxBenchmark = props.favorite.InputParameters.sbs.cxBenchmark
    casBenchmark = props.favorite.InputParameters.sbs.casBenchmark
    responseCount = props.favorite.InputParameters.sbs.responseCount
    name = `<div class="favoriteFlex"><div>${productDivision.code}</div><div class="forwardTitleArrow"></div><div>${name}</div></div>`
  }

  let score = 0
  if (type.toLowerCase() === 'kpi') {
    const _score = props.favorite.InputParameters.kpi.score
    score = _score ? _score : '-'
  } else if (ViewType === 2 || ViewType === 9) {
    if (props.favorite.InputParameters.sasParent.toLowerCase() === 'cx') {
      const _score = props.favorite.InputParameters.cxScoreDetails.cxScore.score
      score = _score ? _score : '-'
    }
    else {
      if (props.favorite.InputParameters.cxScoreDetails.cas.responseCount)
        score = props.favorite.InputParameters.cxScoreDetails.cas.score
      else
        score = '-'
    }
  }

  const clickOnTooltip = (e) => {
    e.stopPropagation()
  }

  const getRrecommendation = (recommendation) => {
    return utils.getRrecommendation(recommendation)
  }

  const getRecommendationColorCode = (recommendation) => {
    return utils.getRecommendationColorCode(recommendation)
  }

  return (
    <React.Fragment>
      {
        ViewType !== 1 ? <div
          onClick={() => props.showDetail(props.favorite)}
          className={styles.cardContainer}
        >
          <div className={styles.cardHeader}>
            <div className={styles.cardTitle} dangerouslySetInnerHTML={{ __html: title }}></div>
            <div id="favorite"
              onClick={(e) => props.removeFavorite(e, props.favorite)}
              className={`${styles.favoritePinRed} ${styles.tooltip}`}><span onClick={(e) => clickOnTooltip(e)} className={styles.tooltiptext}>Unpin from Favorites</span></div>
          </div>
          {
            view !== null ? <div className={styles.cardSubHeader0}>
              <div className={styles.cardSubTitle0}>{view}</div>
            </div> : null
          }
          {
            (type.toLowerCase() === 'kpi' || type.toLowerCase() === 'nba' || ViewType === 2 || ViewType === 9) ?
              <div className={`${styles.cardSubHeader} ${(type.toLowerCase() === 'kpi' || ViewType === 2 || ViewType === 9) ? `${styles.kpitile}` : ''}`}>
                <div className={(type.toLowerCase() === 'kpi' || type.toLowerCase() === 'nba') ? styles.cardSubTitle : styles.cardSubTitlehidden} dangerouslySetInnerHTML={{ __html: subTitle }} ></div>
                <div className={(type) ? `${styles.subTitle}` : ''}>{type}</div>
              </div>
              : null
          }
          {
            (type.toLowerCase() === 'kpi' || type.toLowerCase() === 'nba' || ViewType === 2 || ViewType === 9) ?
              <div className={styles.cardBody}>
                <div className={styles.innerLayout1}>
                  <div className={styles.bodyTitle}>{type.toLowerCase() === 'nba' ? <span className={styles.nbaHidden}>Score</span> : 'Score'}</div>
                  <span className={styles.bodyValue}>
                    {
                      type.toLowerCase() === 'nba' ? <span className={styles.nbaHidden}>0</span> : (typeof score === 'number' ? Number(score).toFixed(0) : <div className={prodStyles.dash}>-</div>)
                    }
                  </span>
                </div>
              </div> : null
          }
        </div>
          :
          <div
            onClick={() => props.showDetail(props.favorite)}
            className={`${prodStyles.cardContainer} ${type === "productdivision" ? `${prodStyles.cardMargin}` : ""
              } ${type === "product" ? `${prodStyles.cardAfter}` : ""}`}
          >
            <div className={prodStyles.cardHeader}>
              <div className={prodStyles.cardTitle} dangerouslySetInnerHTML={{ __html: name }}></div>
              <div id="favorite"
                onClick={(e) => props.removeFavorite(e, props.favorite)}
                className={`${styles.favoritePinRed} ${styles.tooltip}`}><span onClick={(e) => clickOnTooltip(e)} className={styles.tooltiptext}>Unpin from Favorites</span></div>
            </div>
            <div className={prodStyles.cardBody}>
              <div className={prodStyles.innerLayout}>
                <div className={prodStyles.bodyTitle}>CX Score</div>
                {
                  cxScore ?
                    <span
                      className={`${prodStyles.bodyValue} ${cxScore >= cxBenchmark ? "text-color-green" : "text-color-red"
                        }`}
                    >
                      {Number(cxScore).toFixed(0)}
                      <span
                        className={
                          (cxScore === lastQuarterCxScore) ? `${prodStyles.arrowNoChange}` : (cxScore > lastQuarterCxScore) ? `${prodStyles.arrowUp}` : `${prodStyles.arrowDown}`
                        }
                      ></span>
                    </span> : <div className={prodStyles.dash}>-</div>
                }
              </div>
              <div className={prodStyles.innerLayout}>
                <div className={prodStyles.bodyTitle}>CAS</div>
                {
                  responseCount ?
                    <span
                      className={`${prodStyles.bodyValue} ${cas >= casBenchmark ? "text-color-green" : "text-color-red"
                        }`}
                    >
                      {Number(cas).toFixed(0)}
                      <span
                        className={
                          (cas === lastQuarterCas) ? `${prodStyles.arrowNoChange}` : (cas > lastQuarterCas) ? `${prodStyles.arrowUp}` : `${prodStyles.arrowDown}`
                        }
                      ></span>
                    </span> : <div className={prodStyles.dash}>-</div>
                }
              </div>
              <div className={prodStyles.innerLayout}>
                <div className={prodStyles.bodyTitle}>Volatility</div>
                {
                  cxScore ? <span className={prodStyles.bodyValue}>{volatility}</span> :
                    <div className={prodStyles.dash}>-</div>
                }
              </div>
            </div>
            <div
              className={`${prodStyles.cardFooter} ${getRecommendationColorCode(recommendation)}`}
            >
              <b>{getRrecommendation(recommendation)}</b>
            </div>
          </div>
      }
    </React.Fragment>
  );
}

export default Favorite;
